"use client";

import { PageEventSchema } from "@/sanity/pages/PageEventTemplate";
import AffiliateWebhookProvider from "@/components/global/AffiliateWebhookProvider";
import { EventContents } from "@/components/pageComponents/event/EventContents";
import { EventFaq } from "@/components/pageComponents/event/EventFaq";
import { EventFinalCta } from "@/components/pageComponents/event/EventFinalCta";
import { EventHero } from "@/components/pageComponents/event/EventHero";
import { EventHost } from "@/components/pageComponents/event/EventHost";
import { EventMarquee } from "@/components/pageComponents/event/EventMarquee";
import ScrollingBanner from "@/components/pageComponents/global/ScrollingBanner";
import { EventWhyAttend } from "@/components/pageComponents/event/EventWhyAttend";

export default function PageEventJSX({ data }: { data: PageEventSchema }) {
  const marqueeItems = data.s6MarqueeItems ?? [];

  return (
    <AffiliateWebhookProvider enabled={data.forwardAffiliateToWebhook === true}>
      <div className="relative w-full bg-white">
        <EventHero data={data} />
        {/* Same scrolling banner as the homepage WorldMapSection */}
        <ScrollingBanner
          className="border-y-0"
          words={data.scrollingWords?.words}
          wordsI18n={data.scrollingWords?.wordsI18n}
        />
        <EventContents data={data} />
        <EventWhyAttend data={data} />
        <EventHost data={data} />
        <EventFaq data={data} />
        <ScrollingBanner
          className="border-y-0"
          words={data.scrollingWords?.words}
          wordsI18n={data.scrollingWords?.wordsI18n}
        />
        <EventFinalCta data={data} />
      </div>
    </AffiliateWebhookProvider>
  );
}
